export default theme => ({
	textButton: {
		color: 'white',
		fontWeight: 700,
		minWidth: 170
	}
});
